import React from 'react';
import DefaultPanelManuelRecipient from '../components/PanelsComponents/ManuelRecipient/DefaultPanelManuelRecipient';
import { email } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const Panel_B07b_SendMoneyToEmailManually = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultPanelManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
    manualName={email}
    isHollow
  />
);

export default Panel_B07b_SendMoneyToEmailManually;
